import type { SupportedLocale } from '@erp/shared';

export const catalogReadinessTranslations = {
  de: {
    UNKNOWN: 'Bestand ungeklärt',
    DEFERRED: 'Bestandsübernahme zurückgestellt',
    missingPrice: 'Preis noch erfassen',
    unknownQuantity: 'Unbekannt',
    help: 'Ungeklärte Artikel können in einen Entwurf aufgenommen werden. Erfassen Sie fehlende Preise ausdrücklich. Bestandsabhängige Aktionen benötigen einen bestätigten Artikeltyp und die freigegebene Bestandsübernahme.',
  },
  en: {
    UNKNOWN: 'Inventory unconfirmed',
    DEFERRED: 'Opening inventory deferred',
    missingPrice: 'Enter a price',
    unknownQuantity: 'Unknown',
    help: 'Products with unresolved details can be added to a draft. Enter missing prices explicitly. Inventory-dependent actions require a confirmed product type and approved opening inventory.',
  },
  fr: {
    UNKNOWN: 'Stock à clarifier',
    DEFERRED: 'Reprise du stock différée',
    missingPrice: 'Prix à saisir',
    unknownQuantity: 'Inconnu',
    help: 'Les articles à clarifier peuvent être ajoutés à un brouillon. Saisissez explicitement les prix manquants. Les actions liées au stock exigent un type d’article confirmé et une reprise du stock approuvée.',
  },
  tr: {
    UNKNOWN: 'Stok doğrulanmadı',
    DEFERRED: 'Açılış stoku aktarımı ertelendi',
    missingPrice: 'Fiyat girin',
    unknownQuantity: 'Bilinmiyor',
    help: 'Bilgileri eksik ürünler taslağa eklenebilir. Eksik fiyatları açıkça girin. Stoka bağlı işlemler, doğrulanmış ürün türü ve onaylanmış açılış stoku aktarımı gerektirir.',
  },
  es: {
    UNKNOWN: 'Existencias por confirmar',
    DEFERRED: 'Carga inicial de existencias aplazada',
    missingPrice: 'Introduzca un precio',
    unknownQuantity: 'Desconocido',
    help: 'Los artículos con datos pendientes se pueden añadir a un borrador. Introduzca expresamente los precios que faltan. Las acciones que dependen del stock requieren un tipo de artículo confirmado y una carga inicial de existencias aprobada.',
  },
} satisfies Record<
  SupportedLocale,
  { UNKNOWN: string; DEFERRED: string; missingPrice: string; unknownQuantity: string; help: string }
>;
